import CardNumber from "./Common/CardNumber";

const RESULT_DATA = [
  {
    Heading: "A Reliable Partner",
    Details: (
      <>
        When two young entrepreneurs thought of an idea that can change the
        definition of people networking, they also required a fantastic team to
        convert that idea into a reality. After going through many ups and downs
        with the first vendor, Robert and Panashe finally found ultroNeous to
        take care of their multimillionaire idea. We became their technology
        partner, working on multiple releases to launch their features to test
        the market in a flexible with their working manner to support these two
        brilliant minds.
      </>
    ),
  },
  {
    Heading: "An Awesome Product.",
    Details: (
      <>
        When the idea turned into reality, the product went for testing with a
        large scale of people. The product idea, as well as the product, stood
        out proudly in the middle of a colossal product crowd. The app concept,
        the detailing of the flow, the ever-working features and great marketing
        took it to the next step. This is a stage where founders could sit with
        the investors and showcase this beauty to them with a proper working
        mode. They were getting the approvals and benefits, making the app a
        million-user product soon.
      </>
    ),
  },
  {
    Heading: "A Growing User base.",
    Details: (
      <>
        When you have a beautiful product with features working as expected, you
        can be confident to market it everywhere. Whether an Apple store, a
        University, a Cafe, a Pub or a Restaurant, this app always draws
        attention and gains praise. With each passing day, it gains new users.
        The users who purchase the tags and bands, the users who feel safe
        sharing their data on the app and users who are growing their network
        rapidly with this one-tap solution.
      </>
    ),
  },
  {
    Heading: "An Ongoing Feature Releases.",
    Details: (
      <>
        The product and the idea have had such a massive success that the client
        has already listed out multiple release plans with an exciting set of
        features in the roadmap. We release a new version each quarter which
        expands the reach of the product to the new verticals and user base. The
        product is getting bigger daily and will compete with the best soon.
      </>
    ),
  },
];

const Result = () => (
  <>
    <div className="flex justify-start p-4 md:py-16 md:px-10 xl:pb-16 xl:px-32 xl:pt-0">
      <div className="w-1/2 pl-2 md:pl-4 xl:pl-16">
        <CardNumber
          description="Solution on table"
          number="04"
          title="ACHIEVEMENTS"
        />
      </div>
    </div>
    <div className="flex justify-end pb-16 text-justify items-start">
      <div className="w-full xl:w-10/12 pl-2 pt-4 md:p-0">
        <div className="flex flex-col w-full p-4 md:pl-10 xl:pl-8 md:pr-16">
          {RESULT_DATA.map((value) => (
            <div
              key={value.Heading}
              className="w-full my-4 border border-solid border-gray-300"
            >
              <div className="py-8 px-4 md:p-8">
                <h2 className="text-xl md:text-lg font-medium mb-2">
                  <span className="font-josefin">{value.Heading}</span>
                </h2>
                <p className="text-base font-light">
                  <span className="font-josefin">{value.Details}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </>
);
export default Result;
